import useSwr from 'swr'

export const useRelatedArticlesByCategory = (category) => {
  const { data, error } = useSwr(
    `/jsonapi/v1/articles?filter[category]=${category}&page[limit]=6`,
  )
  const relatedArticlesByCategory = data?.filter(
    (item) => item.heroImage && item.heroImage.url,
  )

  return {
    relatedArticlesByCategory,
    error,
  }
}
